/**
 * Cmarkdownmath Component
 * Renders LaTeX math for markdown inline and block content.
 */
'use client';
import type { CSSProperties } from 'react';
import { useMemo } from 'react';
import { getMarkdownBlockRootStyle } from '../Cmarkdown/markdownBlockStyles';
import { renderLatexToHtml } from '../Cmarkdown/katex-renderer';
const FALLBACK_STYLE: CSSProperties = {
    color: 'inherit',
    whiteSpace: 'pre-wrap',
};
export interface CmarkdownmathProps {
    latex: string;
    displayMode: boolean;
    className?: string;
    style?: CSSProperties;
}
export function Cmarkdownmath({ latex, displayMode, className, style, }: CmarkdownmathProps) {
    const renderedMath = useMemo(() => renderLatexToHtml({ latex, displayMode }), [displayMode, latex]);
    if (displayMode) {
        return (
        <div className={className} style={getMarkdownBlockRootStyle({
                textAlign: 'center',
                ...style,
            })}>
          {renderedMath ? (<div dangerouslySetInnerHTML={{ __html: renderedMath }}/>) : (<code style={{
                    ...FALLBACK_STYLE,
                    ...style,
                }}>
              {latex}
            </code>)}
        </div>
      );
    }
    if (!renderedMath) {
        return (
        <code className={className} style={{
                ...FALLBACK_STYLE,
                ...style,
            }}>
          {latex}
        </code>
      );
    }
    return (
      <span className={className} style={style} dangerouslySetInnerHTML={{ __html: renderedMath }}/>
    );
}
